<ng-container *transloco="let t">
  <div class="login-attempt">
    <div class="text-content">
      <atm-text-h6 [fontColor]="eFontColor.tertiary" [fontWeight]="eFontWeight.bold">
        {{ data.newSessionAlert ? t('multiSessions.accountLoginAttempt.title') : t('multiSessions.multipleActive.title') }}
      </atm-text-h6>
      <atm-text-caption [fontColor]="eFontColor.tertiary" [fontWeight]="eFontWeight.regular">
        {{
          data.newSessionAlert ? t('multiSessions.accountLoginAttempt.message1') : t('multiSessions.multipleActive.message1')
        }}.
      </atm-text-caption>
      <atm-text-caption [fontColor]="eFontColor.tertiary" [fontWeight]="eFontWeight.regular">
        {{
          data.newSessionAlert ? t('multiSessions.accountLoginAttempt.message2') : t('multiSessions.multipleActive.message2')
        }}.
      </atm-text-caption>
    </div>
    <div class="buttons">
      <mol-button id="btn-contact" [size]="eComponentsSize.m" [type]="eButtonType.secondary" (submitEvent)="openMail()">{{
        t('contactUs')
      }}</mol-button>
      <mol-button id="btn-primary" [size]="eComponentsSize.m" [type]="eButtonType.primary" (submitEvent)="dismiss()">{{
        data.newSessionAlert ? t('multiSessions.accountLoginAttempt.dismiss') : t('multiSessions.multipleActive.accept')
      }}</mol-button>
    </div>
  </div>
</ng-container>
